// cart-moq-enforce.js
// Enforces product.metafields.custom.cantidad_minima (MOQ) and
// custom.unidades_lote (step) when the customer edits a line-item
// quantity in the cart or cart drawer.
//
// Reads `data-moq` and `data-step-qty` from the line-item's <input>.
// Snaps invalid values to a valid quantity, renders an inline alert
// inside `.line-item__info`, and forwards to the original method.
// The trash link bypasses enforcement (detected by input.value !== targetQty).

(function () {
  'use strict';

  function enforceMoqStep(qty, moq, step) {
    if (moq === 1 && step === 1) return { qty: qty, message: '' };
    var adjusted = qty;
    var message = '';
    if (adjusted < moq) {
      adjusted = moq;
      message =
        'La cantidad mínima para este producto es de ' +
        moq +
        ' unidades. Si quieres eliminarlo, usa la papelera.';
    }
    if (step > 1) {
      var remainder = (adjusted - moq) % step;
      if (remainder !== 0) {
        adjusted = adjusted - remainder;
        if (adjusted < moq) adjusted = moq;
        message =
          'La cantidad debe pedirse en múltiplos de ' +
          step +
          ' unidades (por ejemplo: ' +
          moq +
          ', ' +
          (moq + step) +
          ', ' +
          (moq + step * 2) +
          ').';
      }
    }
    return { qty: adjusted, message: message };
  }

  function showInlineError(lineItem, message) {
    var info = lineItem.querySelector('.line-item__info');
    if (!info) return;
    var existing = info.querySelector('p[role="alert"].cart-moq-warning');
    if (existing) existing.remove();
    var errorSvg =
      '<svg width="14" viewBox="0 0 18 18">' +
      '<path d="M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9Z" fill="#eb001b"></path>' +
      '<path d="M5.29289 6.70711L11.2929 12.7071L12.7071 11.2929L6.70711 5.29289L5.29289 6.70711ZM6.70711 12.7071L12.7071 6.70711L11.2929 5.2929L5.29289 11.2929L6.70711 12.7071Z" fill="#ffffff"></path>' +
      '</svg>';
    info.insertAdjacentHTML(
      'beforeend',
      '<p class="text-with-icon text-error text-xs cart-moq-warning" role="alert">' +
        errorSvg +
        ' ' +
        message +
        '</p>'
    );
  }

  function clearInlineError(lineItem) {
    var info = lineItem && lineItem.querySelector('.line-item__info');
    if (!info) return;
    var existing = info.querySelector('p[role="alert"].cart-moq-warning');
    if (existing) existing.remove();
  }

  function patchLineItemQuantity() {
    var ctor = window.customElements && window.customElements.get('line-item-quantity');
    if (!ctor) return false;
    var proto = ctor.prototype;
    if (proto.__moqPatched) return true;

    var original = proto._changeLineItemQuantity;
    if (typeof original !== 'function') return false;
    proto._changeLineItemQuantity = function (lineKey, targetQuantity) {
      var input = this.querySelector('.quantity-input');
      if (!input) return original.call(this, lineKey, targetQuantity);

      var moq = Math.max(1, parseInt(input.dataset.moq, 10) || 1);
      var step = parseInt(input.dataset.stepQty, 10) || 1;
      if (step < 1) step = 1;
      if (step > moq) step = moq;

      if (moq === 1 && step === 1) {
        return original.call(this, lineKey, targetQuantity);
      }

      var inputQty = parseInt(input.value, 10);
      var fromInput = Number.isFinite(inputQty) && inputQty === targetQuantity;
      if (!fromInput) {
        return original.call(this, lineKey, targetQuantity);
      }

      var result = enforceMoqStep(targetQuantity, moq, step);
      var adjusted = result.qty;
      var message = result.message;
      var lineItem = this.closest('line-item, tr');

      clearInlineError(lineItem);

      if (adjusted !== targetQuantity) {
        input.value = adjusted;
        if (lineItem && message) showInlineError(lineItem, message);
      }

      return original.call(this, lineKey, adjusted);
    };
    proto.__moqPatched = true;
    return true;
  }

  if (!patchLineItemQuantity()) {
    document.addEventListener('DOMContentLoaded', patchLineItemQuantity, { once: true });
  }
})();
